/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Incode_LabelInputs */

const en_new_project_incode_label = /** @type {(inputs: New_Project_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Incode`)
};

const fr_new_project_incode_label = /** @type {(inputs: New_Project_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode du projet`)
};

const de_new_project_incode_label = /** @type {(inputs: New_Project_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt Incode`)
};

const it_new_project_incode_label = /** @type {(inputs: New_Project_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto Incode`)
};

const ru_new_project_incode_label = /** @type {(inputs: New_Project_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект Incode`)
};

const es_new_project_incode_label = /** @type {(inputs: New_Project_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto Incode`)
};

const zh_cn2_new_project_incode_label = /** @type {(inputs: New_Project_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目编码`)
};

const ja_new_project_incode_label = /** @type {(inputs: New_Project_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト・インコード`)
};

const hi_new_project_incode_label = /** @type {(inputs: New_Project_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट इनकोड`)
};

const pt_pt2_new_project_incode_label = /** @type {(inputs: New_Project_Incode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto Incode`)
};

/**
* | output |
* | --- |
* | "Project Incode" |
*
* @param {New_Project_Incode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_incode_label = /** @type {((inputs?: New_Project_Incode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Incode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_incode_label(inputs)
	if (locale === "de") return de_new_project_incode_label(inputs)
	if (locale === "it") return it_new_project_incode_label(inputs)
	if (locale === "ru") return ru_new_project_incode_label(inputs)
	if (locale === "es") return es_new_project_incode_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_incode_label(inputs)
	if (locale === "ja") return ja_new_project_incode_label(inputs)
	if (locale === "hi") return hi_new_project_incode_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_incode_label(inputs)
	return en_new_project_incode_label(inputs)
});